// extracted by mini-css-extract-plugin
export default {"home_main":"Main_home_main__jgtAH"};